var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanishArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.75 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#621e80;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#eab2ff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.1,21.52l-13.57-11.6c-.66-.56-1.45-.86-2.29-.86-1.4,0-2.66.83-3.29,2.16-.82,1.73-.4,3.85.99,5.04l5.14,4.4H4.03c-2.22,0-4.03,1.81-4.03,4.03s1.81,4.03,4.03,4.03h26.05l-5.15,4.4c-1.39,1.19-1.81,3.31-.99,5.04.63,1.33,1.89,2.16,3.29,2.16.83,0,1.65-.3,2.3-.86l13.57-11.6c.89-.76,1.4-1.92,1.4-3.17s-.51-2.41-1.4-3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.75,
    width: 49,
    height: 49,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.74,42.17h-6.06v-15.75c0-1.98-.44-3.45-1.32-4.42s-2.28-1.46-4.2-1.46c-2.55,0-4.42.68-5.6,2.04-1.18,1.36-1.77,3.64-1.77,6.83v12.76h-6.03v-25.61h4.72l.85,3.36h.31c.86-1.22,2.07-2.16,3.65-2.83,1.57-.66,3.32-1,5.24-1,6.81,0,10.22,3.13,10.22,9.38v16.7ZM76.22,13.43c-.72,0-1.42-.14-2.12-.41-.69-.27-1.37-.57-2.04-.9-.67-.33-1.32-.63-1.95-.9-.63-.27-1.24-.41-1.82-.41-1.39,0-2.32.89-2.8,2.66h-3.13c.21-2.15.87-3.78,1.99-4.91,1.12-1.13,2.55-1.69,4.3-1.69.74,0,1.45.14,2.16.41s1.39.57,2.05.9c.67.33,1.31.63,1.94.9s1.23.41,1.81.41c1.35,0,2.26-.89,2.72-2.66h3.21c-.21,2.07-.87,3.69-1.98,4.85s-2.56,1.75-4.34,1.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishArrow);
export default __webpack_public_path__ + "static/media/spanish-arrow.0aaa6bf074e5dd03ad1647e94eeeacf2.svg";
export { ForwardRef as ReactComponent };